import { render, staticRenderFns } from "./bannerList.vue?vue&type=template&id=47cc0db0&scoped=true"
import script from "./bannerList.vue?vue&type=script&lang=js"
export * from "./bannerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cc0db0",
  null
  
)

export default component.exports